{
  "lastUpdatedAt": "2026-05-18T08:06:25.927Z",
  "lastFetchAttemptAt": "2026-05-18T08:06:25.927Z",
  "organization": null,
  "parseError": null,
  "fetchError": null
}